document.addEventListener('DOMContentLoaded', function () {
	let header = document.getElementsByTagName('header')[0];

	let content = document.getElementsByTagName('main')[0];
	let navBar = document.getElementById('mobile-menu');
	let headerLock = false;
	let originalHeaderHeight = header.offsetHeight;
	let headerHeight = header.offsetHeight + 300;
	let currentPos = 0;
	let previousPos = 0;

	window.addEventListener('scroll', function () {
		//get current scroll position
		currentPos = window.pageYOffset;

		//when these conditions are true, the header can be revealed and if the scroll is in the range but is going back up
		if (
			!headerLock &&
			currentPos > headerHeight &&
			previousPos > currentPos
		) {
			//enable the header lock
			headerLock = currentPos;

			//add sticky nav class
			// header.classList.add('nav-revealed');
			header.classList.add('sticky-nav');

			if (this.window.innerWidth > 1024) {
				content.style.paddingTop = originalHeaderHeight + 'px';
			}
		} else if (
			headerLock &&
			previousPos > currentPos &&
			currentPos > headerHeight
		) {
			//update header lock
			headerLock = currentPos;
		} else if (
			(headerLock && currentPos > headerLock + headerHeight / 2) ||
			currentPos < headerHeight
		) {
			//add hider class
			header.classList.add('sticky-reset');

			setTimeout(function () {
				//remove hide and revealed class
				header.classList.remove('sticky-reset');
				// header.classList.remove('nav-revealed');
				header.classList.remove('sticky-nav');
				if (this.window.innerWidth > 1024) {
					content.style.paddingTop = 0;
				}

				//remove header lock
				headerLock = false;
			}, 10);
		}

		//update previous position
		previousPos = currentPos;
	});
});
